import { Box, Popper, TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import SearchResultList from "../../../../common/components/search/SearchResultList.tsx";
import { useAddRelationSearch } from "./AddRelationSearch.hooks.ts";
import { useTranslation } from "../../../../localization/useTranslation.ts";
import { SearchResultViewModel } from "../../../../common/components/search/SearchResultList.types.ts";

export interface AddRelationSearchProps {
    onRelationSelected: (result: SearchResultViewModel) => void;
    onClose: () => void;
}

function AddRelationSearch(props: AddRelationSearchProps) {
    const { translateString } = useTranslation();
    const { fetchSuggestions, isLoading, suggestions, searchInputRef, onShowMoreForEntityTypeClick, isEntitySpecificSearch } = useAddRelationSearch();

    return (
        <Autocomplete
            freeSolo
            filterOptions={(x) => x}
            options={[]}
            disablePortal
            sx={{
                paddingY: "3px",
            }}
            slots={{
                popper: (popperProps) => (
                    <Popper {...popperProps} open sx={{ zIndex: 10000 }} disablePortal={false}>
                        <Box onMouseDown={(e) => e.preventDefault()}>
                            <SearchResultList
                                // A narrow container such as the side panel cannot fit the default list width; the
                                // overflow pushes the whole page sideways.
                                width={Number(popperProps.style?.width)}
                                items={suggestions}
                                isLoading={isLoading}
                                onItemSelected={props.onRelationSelected}
                                isEntitySpecificSearch={isEntitySpecificSearch}
                                onShowMoreClick={(type) => onShowMoreForEntityTypeClick(searchInputRef.current?.value ?? "", type)}
                            />
                        </Box>
                    </Popper>
                ),
            }}
            renderInput={(params) => (
                <TextField
                    inputRef={searchInputRef}
                    variant={"standard"}
                    {...params}
                    placeholder={translateString("addRelation")}
                    onChange={(e) => fetchSuggestions(e.target.value)}
                    onBlur={props.onClose}
                    sx={(theme) => ({ "& .MuiInputBase-input": { fontSize: theme.typography.pxToRem(14) } })}
                />
            )}
        />
    );
}

export default AddRelationSearch;
